<Panel mt="sm">

  <Panel mt="xs" pb="nm" border-bottom="2">
    <XlsInjectorsList bind:injectors={rpt.definition.injects}/>
  </Panel>
    
  <Panel mt="md" pb="nm" border-bottom="2">
    <XlsBuilderTemplate bind:rpt={rpt}/>
  </Panel>

  <Panel mt="md">
    <XlsBuilderReport rpt={rpt}/>
  </Panel>

</Panel>


<script>
  import { tick, createEventDispatcher } from 'svelte'
  import XlsInjectorsList from './XlsInjectorsList.svelte'
  import XlsBuilderTemplate from './XlsBuilderTemplate.svelte'
  import XlsBuilderReport from './XlsBuilderReport.svelte'
  import { Panel, Icon, Heading } from 'svelte-stylo'
  import { TextField, NotesField, SelectField } from 'svelte-stylo-kit'

  export let 
    rpt;

  let 
    emit = createEventDispatcher();

</script>

